module.exports = __webpack_public_path__ + "static/media/secondHand.0c0ab2ee.svg";